import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";
import { HRM3130_R01Content } from "./Content_HRM3130_R01";
import { HRM3130_R01TaxTableDto } from "./Dto_HRM3130_R01";
import { HRM3130_R01SearchSection } from "./SearchSection_HRM3130_R01";
import { Table_HRM3130_R01 } from "./Table_HRM3130_R01";
/** 액션바·검색 조건·단일 편집 그리드·메시지를 조립해 반환한다. */
export const Container_HRM3130_R01 = () => {
    const gridRef = useRef<AgGridReact<HRM3130_R01TaxTableDto>>(null); // 편집 확정·스크롤 공유
    const { setMessage } = useUiuxStore(); // 화면 결과 메시지 변경 함수
    const content = HRM3130_R01Content({ gridRef, setMessage }); // 버튼 동작 연결
    return <div className="content-container">
        {/* 기존 권한 액션바에 조회·등록·삭제·저장·Excel·초기화를 연결한다. */}
        <Actionbar onFetchClick={content.fetchData} onCreateClick={content.handleInsertClick} onDeleteClick={content.handleDeleteClick}
            onSaveClick={content.handleSaveClick} onExcelClick={content.handleExcelClick} onInitClick={content.initContainerData} />
        {/* 미리보기와 파일 업로드를 검색 영역에 연결한다. */}
        <HRM3130_R01SearchSection onIncomeTaxSearch={content.handleIncomeTaxSearch} onUploadFile={content.handleUploadFile} />
        <div className="flex-1 flex min-h-0">
            <div className="w-full h-full flex flex-col p-[12px]">
                {/* 기준 Table 구조의 편집 그리드이다. */}
                <Table_HRM3130_R01 gridRef={gridRef} handleInsertClick={content.handleInsertClick} />
            </div>
        </div>
        {/* 화면 처리 결과 메시지를 표시한다. */}
        <Message />
    </div>;
};
